<template>
    <el-dialog
    :visible.sync="visible"
    width="30%"
    :before-close="handleClose">
        <div class="project-create">
            <span class="project-name">项目名称</span>
            <el-input class="project-name-input" placeholder="请输入项目名" v-model="projectName"></el-input>
        </div>
        <div class="project-select">
            <span class="data-source">数据类型</span>
            <el-select v-model="value" placeholder="请选择">
                <el-option
                v-for="item in options"
                :key="item"
                :label="item"
                :value="item">
                </el-option>
            </el-select>
        </div>
        <el-button  class="diagnose-now" type="primary" @click = "SubmitCreateProject">确认</el-button>
        <el-button class="diagnose-later" @click="close">取消</el-button>
    </el-dialog>
</template>

<script>
  import axios from 'axios';
  export default {
    name:'CreateProject',
    data() {
      return {
        visible:false,
        options: ['电动车','电站'],
        value:'',
        projectName:'',
        res:''
      }
    },
    props:{
        isShow:{
            type:Boolean,
            required:true,
            default:false,
        },
    },
    methods:{
      handleClose(){
          this.visible=false
          this.$emit('closeCreateDialog')
      },
      async SubmitCreateProject(){
        var _this=this
        await axios.post('/proxy_url'+'/project/add',{"name": _this.projectName,"dataType": _this.value}).then(function(response){
          if(response.data.code==200){
            _this.res = response.data.data
          }
          else{
            console.log('create project failed!');
          }
        })
      }
    },
    watch:{
      isShow:{
          handler(newVal){
              this.visible=newVal
          }   
      }
    }
  };
</script>

<style>
.project-name{
  margin-right: 20px;
}
.project-name-input{
  width: 220px;
  margin-top: 20px;
}
.project-select{
  margin-top: 20px;
  margin-bottom: 20px;
}
.data-source{
  margin-right: 20px;
}
.diagnose-now{
  background-color: #0049c8;
  border:none;
  margin-right: 20px;
}
</style>